<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">{{ (customer.firstname) ? customer.firstname + " " + customer.lastName : customer.lastName }}</h1>
                    <!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                                            <route-bread-crumb></route-bread-crumb>
                                        </nav>-->
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                    <base-button size="sm" type="neutral">New</base-button>
                                        <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-9">
<!--                    <div class="card shadow">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Kundenbetreuer</h3>
                                </div>
                                <div class="col">
                                </div>
                                <div class="col text-right">
                                    <el-input
                                        type="search"
                                        class=""
                                        clearable
                                        prefix-icon="el-icon-search"
                                        style="width: 200px"
                                        placeholder="Suche"
                                        v-model="searchSupervisors"
                                        aria-controls="datatables"
                                    >
                                    </el-input>
                                </div>
                            </div>
                        </div>
                        <el-table type="index"
                                  ref="superVisorTable"
                                  class="table-responsive"
                                  :class="type === 'dark' ? 'table-dark': ''"
                                  :header-row-class-name="type === 'dark' ? 'thead-dark': ''"
                                  :default-sort="{ prop: 'lastName', order: 'ascending' }"
                                  empty-text="Keine Einträge vorhanden"
                                  @sort-change="changeSortSupervisors"
                                  :data="filteredSupervisors">
                            <el-table-column prop="lastName" label="Name" min-width="170px" sortable="custom"
                                             :sort-orders="['ascending', 'descending']">
                                <template v-slot="{ row }">
                                    {{ (row.lastName) ? row.lastName : "" }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="firstName" label="Vorname" min-width="170px" sortable="custom"
                                             :sort-orders="['ascending', 'descending']">
                                <template v-slot="{ row }">
                                    {{ (row.firstName) ? row.firstName : '' }}
                                </template>
                            </el-table-column>
                            &lt;!&ndash;                            <el-table-column prop="position" label="Funktion" min-width="170px" sortable="custom"
                                                                         :sort-orders="['ascending', 'descending']">
                                                            <template v-slot="{ row }">
                                                                {{ (row.position) ? row.position : '' }}
                                                            </template>
                                                        </el-table-column>&ndash;&gt;
                            <el-table-column prop="team" label="Team" min-width="170px" sortable="custom"
                                             :sort-orders="['ascending', 'descending']">
                                <template v-slot="{ row }">
                                    {{ (row.team) ? row.team : '' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="telephone" label="Telefon" min-width="170px" sortable="custom"
                                             :sort-orders="['ascending', 'descending']">
                                <template v-slot="{ row }">
                                    <a title="Mobil" v-if="row.telephone" :href="'tel:' + row.telephone">{{ row.telephone }}</a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="mobile" label="Mobil" min-width="170px" sortable="custom"
                                             :sort-orders="['ascending', 'descending']">
                                <template v-slot="{ row }">
                                    <a title="Mobil" v-if="row.mobile" :href="'tel:' + row.mobile">{{ row.mobile }}</a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="email" label="Email" min-width="170px" sortable="custom"
                                             :sort-orders="['ascending', 'descending']">
                                <template v-slot="{ row }">
                                    <a title="Email" v-if="row.email" :href="'mailto:' + row.email">{{ row.email }}</a>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>-->
                    <div class="card shadow">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Kontaktpersonen</h3>
                                </div>
                                <div class="col">
                                </div>
                                <div class="col text-right">
                                    <el-input
                                        type="search"
                                        class=""
                                        clearable
                                        prefix-icon="el-icon-search"
                                        style="width: 200px"
                                        placeholder="Suche"
                                        v-model="searchContacts"
                                        aria-controls="datatables"
                                    >
                                    </el-input>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <el-table type="index"
                                      ref="contactsTable"
                                      class="table-responsive"
                                      :class="type === 'dark' ? 'table-dark': ''"
                                      :header-row-class-name="type === 'dark' ? 'thead-dark': ''"
                                      :default-sort="{ prop: 'lastName', order: 'ascending' }"
                                      empty-text="Keine Einträge vorhanden"
                                      @sort-change="changeSortContacts"
                                      :data="filteredContacts">
                                <el-table-column prop="lastName" label="Name" min-width="170px" sortable="custom"
                                                 :sort-orders="['ascending', 'descending']">
                                    <template v-slot="{ row }">
                                        {{ (row.lastName) ? row.lastName : '' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="firstName" label="Vorname" min-width="170px" sortable="custom"
                                                 :sort-orders="['ascending', 'descending']">
                                    <template v-slot="{ row }">
                                        {{ (row.firstName) ? row.firstName : '' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="position" label="Funktion" min-width="170px" sortable="custom"
                                                 :sort-orders="['ascending', 'descending']">
                                    <template v-slot="{ row }">
                                        {{ (row.position) ? row.position : '' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="telephone" label="Telefon" min-width="170px" sortable="custom"
                                                 :sort-orders="['ascending', 'descending']">
                                    <template v-slot="{ row }">
                                        <a title="Telefon" v-if="row.telephone" :href="'tel:' + row.telephone">{{ row.telephone }}</a>
                                    </template>
                                </el-table-column>
<!--                                <el-table-column prop="telephone2" label="Mobil" min-width="170px" sortable="custom"
                                                 :sort-orders="['ascending', 'descending']">
                                    <template v-slot="{ row }">
                                        <a title="Mobil" v-if="row.telephone2" :href="'tel:' + row.telephone2">{{ row.telephone2 }}</a>
                                    </template>
                                </el-table-column>-->
                                <el-table-column prop="email" label="Email" min-width="170px" sortable="custom"
                                                 :sort-orders="['ascending', 'descending']">
                                    <template v-slot="{ row }">
                                        <a title="Email" v-if="row.email" :href="'mailto:' + row.email">{{ row.email }}</a>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="card-footer d-flex justify-content-end"
                             :class="type === 'dark' ? 'bg-transparent': ''">
                            <base-pagination v-model="pagination" :total="total" :perPage="perPage"></base-pagination>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3">
                    <div class="card shadow">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Kontakt</h3>
                                </div>
                                <div class="col">
                                </div>
                                <div class="col text-right">
                                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-primary">
                                        <i class="fad fa-envelope-open-text"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div v-if="customer.address1" class="text-nowrap">{{ customer.address1 }}</div>
                                <div v-if="customer.address2" class="text-nowrap">{{ customer.address2 }}</div>
                                <div v-if="customer.address3" class="text-nowrap">{{ customer.address3 }}</div>
                                <div v-if="customer.zip" class="text-nowrap">{{ customer.zip }} {{
                                        customer.city
                                    }}
                                </div>
                                <hr>
                                <div v-if="customer.telephone" class="text-nowrap"><a
                                    :href="'tel:' + customer.telephone">{{ customer.telephone }}</a></div>
                                <div v-if="customer.telephone2" class="text-nowrap"><a
                                    :href="'tel:' + customer.telephone2">{{ customer.telephone2 }}</a></div>
                                <div v-if="customer.email" class="text-nowrap"><a
                                    :href="'mailto:' + customer.email">{{ customer.email }}</a></div>
                                <div v-if="customer.website" class="text-nowrap"><a
                                    :href="'https://' +customer.website">{{ customer.website }}</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </base-header>
        <base-alert v-if="error.length > 0" type="danger">
            <span class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        </base-alert>
<!--        <div class="container-fluid mt&#45;&#45;7">
            <div class="row">
                <div class="col-xl-12 col-lg-12">

                </div>
            </div>
            <div class="row mt-3 mb-3">
                <div class="col-xl-12 col-lg-12">

                </div>
            </div>
        </div>-->
    </div>
</template>
<script>
import UserService from '@/services/user.service';
import BaseAlert from "@/components/BaseAlert";
import {
    ElTable,
    ElTableColumn,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";

export default {
    name: "Contacts",
    components: {
        BaseAlert,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
    },
    methods: {
        getCustomer() {
            UserService.getCustomer(null).then(
                response => {
                    this.supervisors = response.data.supervisors.data;
                    this.contacts = response.data.contacts.data;
                    this.customer = response.data;
                    this.error = '';
                    this.sortTableSupervisors(this.currentSortSupervisors);
                    this.sortTableContacts(this.currentSortContacts);
                },
                error => {
                    this.getError(error);
                }
            );
        },
        getError(error) {
            if (error.response && error.response.status === '401') {
                this.error = 'you are not logged in!';
            } else if (error.response && error.response.status === '403') {
                this.error = 'you are not permitted!';
            } else {
                this.error =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        },
        changeSortSupervisors(sort) {
            this.currentSortSupervisors = (!sort.prop) ? '' : sort.prop;
            this.currentSortDirSupervisors = (!sort.order) ? '' : sort.order;
            this.sortTableSupervisors();
        },
        sortTableSupervisors() {
            this.supervisors.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDirSupervisors === 'descending') modifier = -1;
                if (a[this.currentSortSupervisors].toLowerCase() < b[this.currentSortSupervisors].toLowerCase()) return -1 * modifier;
                if (a[this.currentSortSupervisors].toLowerCase() > b[this.currentSortSupervisors].toLowerCase()) return modifier;
                return 0;
            });
        },
        changeSortContacts(sort) {
            this.currentSortContacts = (!sort.prop) ? '' : sort.prop;
            this.currentSortDirContacts = (!sort.order) ? '' : sort.order;
            this.sortTableContacts();
        },
        sortTableContacts() {
            this.contacts.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDirContacts === 'descending') modifier = -1;
                if (a[this.currentSortContacts].toLowerCase() < b[this.currentSortContacts].toLowerCase()) return -1 * modifier;
                if (a[this.currentSortContacts].toLowerCase() > b[this.currentSortContacts].toLowerCase()) return modifier;
                return 0;
            });
        },
    },
    computed: {
        filteredContacts() {
            if (this.searchContacts === '') {
                this.total = this.contacts.length;
                return this.contacts.filter((item,idx) => (idx >= this.start && idx < this.start + this.perPage));
            } else {
                const entries = this.contacts.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !this.searchContacts.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.searchContacts.toLowerCase()) : prop.toString(10).toLowerCase().includes(this.searchContacts.toLowerCase())))
                });
                this.total = entries.length;
                return entries.filter((item,idx) => (idx >= this.start && idx < this.start + this.perPage));
            }
        },
        filteredSupervisors() {
            if (this.searchSupervisors === '') {
                return this.supervisors;
            } else {
                return this.supervisors.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !this.searchSupervisors.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.searchSupervisors.toLowerCase()) : prop.toString(10).toLowerCase().includes(this.searchSupervisors.toLowerCase())))
                });
            }
        },
    },
    data() {
        return {
            value: 1,
            customer: {},
            title: '',
            contacts: [],
            searchContacts: '',
            currentSortContacts: 'lastName',
            currentSortDirContacts: 'asc',
            supervisors: [],
            searchSupervisors: '',
            currentSortSupervisors: 'lastName',
            currentSortDirSupervisors: 'asc',
            error: '',
            type: '',
            pagination: 1,
            total: 0,
            start: 0,
            perPage: 10
        };
    },
    created() {
        this.getCustomer();
    },
    watch: {
        pagination(){
            this.start = (this.pagination - 1) * this.perPage;
        }
    }
}
</script>

<style lang="scss">

</style>
